import { Component, Injector, NgZone, OnInit } from '@angular/core';
import { CompletedWorksModel, CompletedWorksService } from "../../../services/completedworks.service";
import { ServiceTaskService } from "../../../services/servicetask.service";
import { DialogBaseComponent } from "../../admin-panel/base-admin-panel/dialog-base/dialog-base.component";
import { ConverterService } from "../../../services/converter.service";

@Component({
  selector: 'app-completed-works-dialog-base',
  templateUrl: './completed-works-dialog-base.component.html',
  styleUrls: ['./completed-works-dialog-base.component.css'],
  standalone: false
})
export class CompletedWorksDialogBaseComponent extends DialogBaseComponent<CompletedWorksModel> implements OnInit {
  private serviceTaskService: ServiceTaskService;
  private service: CompletedWorksService;
  private converterService: ConverterService;
  private ngZone: NgZone;

  public openedTabName: string = "main";
  public isLoading: boolean = true;

  constructor(protected injector: Injector) {
    super(injector);
    this.converterService = injector.get(ConverterService);
    this.service = injector.get(CompletedWorksService);
    this.serviceTaskService = injector.get(ServiceTaskService);
    this.ngZone = injector.get(NgZone);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public override open(model: any, type: { new(): CompletedWorksModel } = undefined) {
    this.openedTabName = "main";
    super.open(model, type);
    this.updateFromJs(model);
    this.loadServiceTasks();
  }

  public updateFromJs(data: any) {
    this.ngZone.run(() => {
      this.model = data;
    });
  }

  private loadServiceTasks() {
    this.isLoading = true;

    if (!this.model) {
      this.objects = [];
      this.isLoading = false;
      return;
    }

    this.model.ServiceTasks = this.model.ServiceTasks ?? [];
    this.objects = [];

    this.serviceTaskService.getAll()
      .subscribe((res) => {
        const selectedTasks = new Set(this.model.ServiceTasks);
        this.objects = res
          .filter(task => task.ObjectId == this.model.ObjectId)
          .map(task => {
            task.IsChecked = selectedTasks.has(task.Id);
            return task;
          });
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
  }

  public submit() {
    this.model.ServiceTasks = [];
    for (var i = 0; i < this.objects.length; i++)
      if (this.objects[i].IsChecked)
        this.model.ServiceTasks.push(this.objects[i].Id);

    this.service.update(this.model)
      .subscribe((res) => {
        this.onCreated.emit();
        this.close();
        super.submit();
      });
  }

  public openTab(name: string, event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();

    this.ngZone.run(() => {
      this.openedTabName = name;
    });
  }
  public isSelected(name: string) {
    return name == this.openedTabName;
  }

  public onToggleAll(value: boolean) {
    this.objects.forEach((command) => {
      command.IsChecked = value;
    });
  }

  public onToggle(val: any) {

  }
  public convertOdometr(value: number) {
    this.model.Odometr = this.converterService.ParseKMeters(value);
  }
  public convertEngineTime(value: number) {
    this.model.WorkTime = value * 3600000;
  }
  public convertDuration(value: number) {
    this.model.Duration = value * 3600000;
  }
}
